import React from "react";
import { Badge } from "@/components/ui";
import { Eye, MousePointerClick } from "lucide-react";
import { ContentPage } from "@/services/bedrock";
import { VideoPageStatsPopup } from "./VideoPageStatsPopup";
import { cn } from "@/lib/utils";

interface OwnProps {
  videoPage: ContentPage;
  className?: string;
}

type Props = OwnProps;

export const VideoPageStatsBadges: React.FC<Props> = ({ videoPage, className }) => {
  const clickCount = videoPage?.viewSummary?.clicks.find(s => s.label === "Clicked")?.value || 0;

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <VideoPageStatsPopup
        contentPageViewSummary={videoPage?.viewSummary}
        trigger={
          <Badge variant="label">
            <div className="flex items-center gap-2 text-xs/3 py-1">
              <Eye className="size-4" />
              <div>{videoPage?.viewSummary?.viewCount || 0}</div>
            </div>
          </Badge>
        }
      />

      {!!videoPage?.callToAction && (
        <Badge variant="label">
          <div className="flex items-center gap-2 text-xs/3 py-1">
            <MousePointerClick className="size-4" />
            <div>{`${clickCount}`}</div>
          </div>
        </Badge>
      )}
    </div>
  );
};
